import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onDeleteCategoryRes } from "./helper";

const deleteCategory = async (id: number) =>
  axios.delete(Routes.DELETE_CATEGORY + "/" + id);

export const useDeleteCategory = () =>
  useMutation({
    mutationKey: [Keys.DELETE_CATEGORY_MUT],
    mutationFn: deleteCategory,
    onSuccess: onDeleteCategoryRes,
  });
